<template>
    <div class="row">
        <div class="col-md-4">
            <servicio-datos-siniestro :id="id" :servicio="servicio" :servicioext="servicioext" />

        </div>
        <div class="col-md-4">
            <servicio-datos-equipo v-if="equipos" :id="id" />
            <servicio-datos-direccion :servicio="servicio" :id="id" :asegurado="asegurado" />

        </div>
        <div class="col-md-4">
            <servicio-datos-asegurado @actualizarasegurado="actualizarasegurado" :servicioext="servicioext" :id="id"
                :servicio="servicio" :asegurado="asegurado" />
        </div>
    </div>
    <div class="row">
        <div class="col-md-8">
            <servicio-datos-visitas @email="email" :cargaseccion="cargaseccion" @actualizar="actualizar" :id="id"
                :servicio="servicio" :perjudicados="perjudicados" :asegurado="asegurado" />

        </div>
        <div class="col-md-4">
            <servicio-datos-perjudicados @actualizarperjudicado="actualizarperjudicado" :id="id" :servicio="servicio"
                v-for="perjudicado in perjudicados" :perjudicado="perjudicado" :key="perjudicado" />
            <div class="row">
                <div class="col-md-8">
                    <input type="text" placeholder="Agregar perjudicado" v-model="nombreperjudicado"
                        class="form-control input-sm">
                </div>
                <div class="col-md-4">
                    <button type="button" class="btn btn-default" @click="mostraragregarperjudicado()">Agregar</button>
                </div>
            </div>
            <div style="margin-top: 15px;" v-if="ver_nuevo_perjudicado" class="card">
                <div class="card-header bg-gray">
                    <h3 class="card-title"><i class="fas fa-address-card mr-2"></i>Agregar perjudicado &nbsp;&nbsp;                        
                    </h3>
                    <div class="card-tools">
                        <button type="button" class="btn btn-success btn-xs editar-perjudicado" @click="guardartoken()"
                            id="boton_guardar_servicio">{{ $t('general.guardar') }} </button>
                        <button style="margin-left: 10px;" type="button" class="btn btn-danger btn-xs editar-perjudicado" @click="cancelartoken()"
                            id="boton_guardar_servicio">Cancelar </button>
                    </div>
                </div>
                <div class="card-body">
                    <servicio-datos-perjudicado-nuevo :nombre_perjudicado="nombreperjudicado" @actualizarperjudicado="actualizarperjudicado" :id="id"
                        :servicio="servicio" :tokenguardarperjudicado="tokenguardarperjudicado" />
                </div>
            </div>
        </div>
    </div>
    <br>
    <div class="row">
        <div class="col-md-4">
            <!--<servicio-datos-equipo v-if="equipos" :id="id" />-->

        </div>
        <div class="col-md-4">

        </div>
        <div class="col-md-4">
            <servicio-datos-perito :perito="perito" :servicioext="servicioext" :servicio="servicio" :id="id" />

        </div>
    </div>
</template>
<script>  
import serviciodatossiniestro from './siniestro/siniestro.vue';
import serviciodatosdireccion from './direccion/direccion.vue';
import serviciodatosperjudicados from './perjudicados/perjudicados.vue'; 
import serviciodatosasegurado from './asegurado/asegurado.vue';
import serviciodatosperito from './perito/perito.vue';
import serviciodatosequipo from './equipos/equipos.vue';
import serviciodatosperjudicadonuevo from './perjudicados/perjudicados_nuevo.vue';

import serviciodatosvisitas from './visitas/visitas.vue';


import { PwgsApi } from '../../../../services/PwgsApi';
export default ({

    props: ['id', 'servicio', 'perjudicados', 'asegurado', 'servicioext', 'perito','cargaseccion'],

    setup() { 

        
            
    },
       data() {
        return {
            tokenguardarperjudicado: false,
            nombre_nuevo_perjudicado: '',
            ver_nuevo_perjudicado:false,
            file: '',
            nombreperjudicado: '',
            idaux: '',
            equipos:false,
        }
    },
    watch:{
        id(){
            this.nombreperjudicado='';
            this.ver_nuevo_perjudicado=false;
        }
    },
    mounted(){
        this.comprobarEquipos();
    },
     methods: {
        email(id){
            this.$emit('email', id);
        },
         async comprobarEquipos(){
            const api = new PwgsApi();
            const ia = await api.get('parametros-pwgs/gestion_de_equipos');
            if(ia['gestion_de_equipos']==1){
                this.equipos=true;
            }else{
                this.equipos=false;
            }
         },
         actualizar(){
            this.$emit('actualizar');
         },
         actualizarasegurado(){
            this.$emit('actualizarasegurado');
         },
         actualizarperjudicado(){
            this.$emit('actualizarperjudicado');
            this.nombreperjudicado='';
            this.ver_nuevo_perjudicado=false;
         },
         async submitFile(id) {
            //https://sonia.pwgs.app/modulos/pwgsapi/index.php/servicios/26100/guardar-documento
            const api = new PwgsApi;
            let formData = new FormData();
            formData.append('ficherosvisitas', this.file,this.file.name);

            await api.post('servicios/' + id + '/guardar-documento',formData);
         },
         async handleFileUpload( event ) {
  
             this.file = event.target.files[0];

         },
         guardartoken(){
            this.tokenguardarperjudicado = !(this.tokenguardarperjudicado);
         },
         mostraragregarperjudicado(){            
             this.ver_nuevo_perjudicado=true;
         },         
         
    },
    components: {
        'servicio-datos-siniestro': serviciodatossiniestro,
        'servicio-datos-direccion': serviciodatosdireccion,
        'servicio-datos-perjudicados': serviciodatosperjudicados,
        'servicio-datos-asegurado': serviciodatosasegurado,
        'servicio-datos-perito': serviciodatosperito,
        'servicio-datos-equipo': serviciodatosequipo,
        'servicio-datos-perjudicado-nuevo': serviciodatosperjudicadonuevo,       
        'servicio-datos-visitas': serviciodatosvisitas,
        
        
    },
})


</script>